import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

const Sort = props => (
  <div className="sort">
    {props.sort === props.desc ? (
      <div
        className="newest-at-top"
        onClick={props.onClick}
        data-ref={props.asc}
      >
        <FormattedMessage
          id={'MyQuests.NewestAtTop'}
          defaultMessage={'NEWEST AT TOP'}
        />
        <div className="caret caret-up" />
      </div>
    ) : (
      <div
        className="oldest-at-top"
        onClick={props.onClick}
        data-ref={props.desc}
      >
        <FormattedMessage
          id={'MyQuests.OldestAtTop'}
          defaultMessage={'OLDEST AT TOP'}
        />
        <div className="caret caret-down" />
      </div>
    )}
  </div>
)

Sort.propTypes = {
  sort: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  asc: PropTypes.string.isRequired,
  desc: PropTypes.string.isRequired
}

export default Sort



// WEBPACK FOOTER //
// ./src/components/mini/Sort.js